import { useContext } from "react";

import { CurrencyContext } from "../CurrencyContext/CurrencyContext";
import Volante from "../Volante/Volante";
import { TableHeader, VolantesContainer } from "./VolantesStyles";

function Volantes(props) {
  const {
    damStatus,
    dni,
    loadDateWithdrawal,
    volantesHook,
    mainCheckboxOnChange,
    checkboxesState,
    secondaryCheckboxOnChange,
    enableCheckbox,
    dateRucHook,
    onChangeVolantesForInvoice,
    refreshBilling,
  } = props;

  const [useDollars] = useContext(CurrencyContext);
  const [volantes, updateVolantes] = volantesHook;
  return (
    <VolantesContainer>
      <TableHeader enableCheckbox={enableCheckbox}>
        {enableCheckbox ? (
          <div>
            <input
              className="checkInvoice"
              type="checkbox"
              onChange={mainCheckboxOnChange}
              checked={checkboxesState.allChecked}
              disabled={checkboxesState.allDisabled}
              style={{
                cursor: `${
                  checkboxesState.allDisabled ? "not-allowed" : "pointer"
                }`,
              }}
            />
          </div>
        ) : null}
        <div className="main-info-header ">IMPORTADOR</div>
        <div>RESTRICCIONES</div>
        <div>ESTADO VOLANTE</div>
        <div>KILOS</div>
        <div>BULTOS</div>
        <div>DÍAS</div>
        <div>RETIRO</div>
        <div>RUC FACTURABLE</div>
        <div>{`MONTO (${useDollars ? "DÓLARES" : "SOLES"})`}</div>
      </TableHeader>
      <div>
        {volantes.map((volante) => {
          const checked = !!(
            checkboxesState.itemsStatus &&
            checkboxesState.itemsStatus[volante.id] &&
            checkboxesState.itemsStatus[volante.id].checked
          );
          const disabled = !!(
            checkboxesState.itemsStatus &&
            checkboxesState.itemsStatus[volante.id] &&
            checkboxesState.itemsStatus[volante.id].disabled
          );
          return (
            <Volante
              damStatus={damStatus}
              dni={dni}
              loadDateWithdrawal={loadDateWithdrawal}
              key={volante.id}
              enableCheckbox={enableCheckbox}
              checkboxOnChange={(ev) =>
                secondaryCheckboxOnChange(volante.id, ev)
              }
              updateVolanteThirdParty={(name, ruc) => {
                const auxVolantes = [...volantes];
                const auxVolante = auxVolantes.find((e) => e.id);
                auxVolante.thirdPartyStatus.option = "reviewing";
                const lastRuc = auxVolante.rucs.pop();
                lastRuc.name = name;
                lastRuc.ruc = ruc;
                auxVolante.rucs.push(lastRuc);
                updateVolantes(auxVolantes);
              }}
              checked={checked}
              dateRucHook={dateRucHook}
              disabled={disabled}
              onChangeVolantesForInvoice={onChangeVolantesForInvoice}
              volante={volante}
              refreshBilling={refreshBilling}
            />
          );
        })}
      </div>
    </VolantesContainer>
  );
}

export default Volantes;
